export default function membershipSelector(state) {
    return state.membership;
}
